export default "__VITE_ASSET__86fa85e5__"